import ServiceRate from "./ServiceRate";
import {
  formatCurrency,
  formatDate,
  formatOsis,
  formatTime,
} from "../utils/format-utils";
import Payer from "./Payer";

export default class SessionInvoice {
  sessionInvoiceId?: number;
  sessionId?: number | null;
  legacyActivityId?: number | null;
  invoiceBatchId?: number | null;
  dateOfService?: Date | null;
  startTime?: string | null;
  endTime?: Date | null;
  durationMinutes?: number | null;
  groupSize?: number | null;
  sessionGroupId?: number | null;
  isBilingual?: boolean | null;
  language?: string | null;
  location?: string | null;
  programId?: number | null;
  program?: string | null;
  serviceId?: number | null;
  service?: string | null;
  clientId?: number | null;
  clientFirstName?: string | null;
  clientLastName?: string | null;
  clientOsis?: string | null;
  providerId?: number | null;
  providerFirstName?: string | null;
  providerLastName?: string | null;
  invoiceDate?: Date | null;
  isInvoiced?: boolean | null;
  lastProcessedAt?: Date | null;
  payerId?: number | null;
  payer?: Payer | null;
  serviceRateId?: number | null;
  serviceRate?: ServiceRate | null;
  calculatedAmount?: number | null;
  balance?: number | null;
  errorMessage?: string | null;
  public constructor(params: SessionInvoice = {} as SessionInvoice) {
    let {
      sessionInvoiceId = 0,
      sessionId = null,
      legacyActivityId = null,
      invoiceBatchId = null,
      dateOfService = null,
      startTime = "",
      endTime = null,
      durationMinutes = null,
      groupSize = null,
      sessionGroupId = null,
      isBilingual = false,
      language = "",
      location = "",
      programId = null,
      program = "",
      serviceId = null,
      service = "",
      clientId = null,
      clientFirstName = "",
      clientLastName = "",
      clientOsis = "",
      providerId = null,
      providerFirstName = "",
      providerLastName = "",
      invoiceDate = null,
      isInvoiced = null,
      lastProcessedAt = null,
      payerId = null,
      payer = null,
      serviceRateId = null,
      serviceRate = null,
      calculatedAmount = 0,
      balance = 0,
      errorMessage = "",
    } = params;
    this.sessionInvoiceId = sessionInvoiceId;
    this.sessionId = sessionId;
    this.legacyActivityId = legacyActivityId;
    this.invoiceBatchId = invoiceBatchId
    this.dateOfService = dateOfService;
    this.startTime = formatTime(startTime);
    this.endTime = endTime;
    this.durationMinutes = durationMinutes;
    this.groupSize = groupSize;
    this.sessionGroupId = sessionGroupId;
    this.isBilingual = isBilingual;
    this.language = language;
    this.location = location;
    this.programId = programId;
    this.program = program;
    this.serviceId = serviceId;
    this.service = service;
    this.clientId = clientId;
    this.clientFirstName = clientFirstName;
    this.clientLastName = clientLastName;
    this.clientOsis = clientOsis && formatOsis(clientOsis);
    this.providerId = providerId;
    this.providerFirstName = providerFirstName;
    this.providerLastName = providerLastName;
    this.invoiceDate = invoiceDate;
    this.isInvoiced = isInvoiced;
    this.lastProcessedAt = lastProcessedAt;
    this.payerId = payerId;
    this.payer = payer && new Payer(payer);
    this.serviceRateId = serviceRateId;
    this.serviceRate = serviceRate && new ServiceRate(serviceRate);
    this.calculatedAmount = calculatedAmount;
    this.balance = balance;
    this.errorMessage = errorMessage;
  }

  get clientName() {
    return this.clientFirstName + " " + this.clientLastName;
  }

  get providerName() {
    return this.providerFirstName + " " + this.providerLastName;
  }

  get formattedDos() {
    return formatDate(this.dateOfService);
  }

  get formattedDuration() {
    return this.durationMinutes + " minutes";
  }

  get rate() {
    return this.serviceRate?.rateSummary;
  }

  get formattedBilledAmount() {
    return formatCurrency(this.calculatedAmount);
  }

  get formattedBalance() {
    return formatCurrency(this.balance);
  }
}
